export const getFullSlugFromStep = ({ step, app, action, extra }) => {
  const stepIdSlug = step?.id?.slice(-4)?.toUpperCase();
  const appSlug = app?.slug;
  let actionSlug = action?.slug;

  if (app?.category !== 'app') {
    return `${appSlug || ''}${extra || ''}${stepIdSlug || ''}`;
  }

  if (!actionSlug) {
    actionSlug = app?.actions?.find((n) => n.id === step?.actionId)?.slug;
  }

  return `${appSlug}${actionSlug?.[0]?.toUpperCase() + actionSlug?.slice(1)}${extra || ''}${stepIdSlug}`;
};
